import React from 'react';
interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  color?: string;
}
export const Spinner: React.FC<SpinnerProps> = ({
  size = 'md',
  color = 'white'
}) => {
  const sizeClass = {
    sm: 'w-4 h-4',
    md: 'w-6 h-6',
    lg: 'w-8 h-8'
  }[size];
  const colorClass = {
    white: 'text-white',
    blue: 'text-blue-600',
    gray: 'text-gray-600'
  }[color] || 'text-white';
  return <div className="flex justify-center items-center" data-id="element-717">
      <svg className={`animate-spin ${sizeClass} ${colorClass}`} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" data-id="element-718">
        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" data-id="element-719"></circle>
        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" data-id="element-720"></path>
      </svg>
    </div>;
};